import ApiInterface from "@/commons/api/ApiInterface";

let mainPath: string = "website/support/files"

export async function uploadFile(file: File, name: string) {
    let upload = await ApiInterface.uploadFile(file, mainPath, true, true);

    return upload != null;
}

export async function getFile(name: string) {
    let files = await ApiInterface.getFilesUUIDS(mainPath + "/" + name);
    if (files != null) {
        if (files.length == 1) {
            return files[0];
        } else {
            window.addInfo("alert", "Più file trovati",
                "Sono stati trovati più file con lo stesso nome (" + mainPath + name + ").<br/>" +
                "Questo non dovrebbe accadere, contatta il WebMaster o riferisci il problema a un Admin!", 20);
            return files[0];
        }
    }
    return null;
}

export async function getFileContent(uuid: string): Promise<string> {
    const url = await ApiInterface.getFileUrl(uuid);
    if (!url) return "";

    const res = await fetch(url);
    const text = await res.text();
    return text;
}